import axios from 'axios';
import { baseConfig } from 'src/config';

const axiosCore = axios.create({
  baseURL: baseConfig.CAPTUR_API_CORE_URL
});

const getHeaders = () => ({
  'client-app-name': process.env.REACT_APP_NAME,
  'client-app-sha': process.env.REACT_APP_RELEASE_SHA ?? 'development'
});

axiosCore.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error.response?.data || 'There is an error!')
);

axiosCore.interceptors.request.use((request) => {
  request.headers = { ...getHeaders(), ...(request.headers ?? {}) };
  return request;
});

export default axiosCore;
